import React from "react";
import { Download, FileText } from "lucide-react";
import Button from "../common/ui/button/Button";
import { formatFileSize } from "../../utils/filePreview";

interface TooLargePreviewProps {
  fileName: string;
  fileSize: number;
  sizeLimit: number;
  onDownload: () => void;
}

export const TooLargePreview: React.FC<TooLargePreviewProps> = ({
  fileName,
  fileSize,
  sizeLimit,
  onDownload,
}) => {
  return (
    <div className="flex h-full min-h-[400px] flex-col items-center justify-center p-8 text-center">
      <FileText className="mb-6 h-24 w-24 text-gray-400 dark:text-gray-600" />
      <h3 className="mb-2 text-xl font-semibold text-gray-900 dark:text-gray-100">
        File Too Large to Preview
      </h3>
      <p className="mb-1 text-gray-600 dark:text-gray-400">
        {fileName} ({formatFileSize(fileSize)})
      </p>
      <p className="mb-6 text-sm text-gray-500 dark:text-gray-500">
        Files larger than {formatFileSize(sizeLimit)} cannot be previewed in
        the browser
      </p>
      <Button
        variant="primary"
        size="md"
        onClick={onDownload}
        startIcon={<Download className="h-4 w-4" />}
      >
        Download File
      </Button>
    </div>
  );
};
